import React from "react"
import merge from "lodash/merge"

import AffordabilityCalculator from "activities/calculators/affordability"

export default (props) => (
  <AffordabilityCalculator
    {...merge(
      {
        steps: [
          {
            title: "Can You Afford a Mortgage?",
            subtitle: "Give us a little information and we\'ll tell you how realistic it\'d be to pay a monthly mortgage on your income.",
            details: {
              question: "What is your projected monthly mortgage payment?"
            }
          },
          {
            title: "Can You Afford a Mortgage?",
            subtitle: "Okay, now enter your monthly income.",
            details: {
              question: "What is your monthly income?"
            },
            buttonText: "Next"
          },
          {
            title: "Can You Afford a Mortgage?",
            subtitle: "Okay, now divide your monthly income into a few expense categories.",
            details: {
              lockedMonthlyOptions: ["Mortgage"],
              monthlyExpenseOptions: ["Mortgage", "Phone", "Internet", "Car Payment", "Car Insurance", "Gas", "Food", "Entertainment", "Clothing", "Other"],
              yearlyExpenseOptions: ["Life Insurance", "Medical", "Car Repairs", "Vacation", "Furniture", "Gifts", "Emergency", "Other"]
            }
          },
          {
            title: "Can You Afford a Mortgage?",
            subtitle: "Let\'s take a look at the results!",
            details: {
              question: "Can you afford this mortgage?",
              goalLabel: "Projected Mortgage Payment",
              results: [
                {
                  answer: "Yes, you can afford this mortgage. No problem.",
                  message: (savings) =>
                    "You're well within the ability to afford this mortgage. You're saving " +
                    savings +
                    " of your monthly income, after the mortgage; that's good. Don't get cocky, though: if you have other debts, or if you didn't account for your savings goals in the budget, consider giving it another go to make sure you're thinking of everything.",
                  value: 90
                },
                {
                  answer: "Yes, you can afford this mortgage. You're safe",
                  message: (savings) =>
                    "As long as you've included bills, expenses, savings goals, and debt pay down in your budget, you're probably safe. You're saving " +
                    savings +
                    " of your monthly income, after the mortgage; that's good. Keep it up. Resist the urge to buy more house than you need, and save as much  of that extra income as you can.",
                  value: 70
                },
                {
                  answer: "Mmm, you can barely afford this mortgage.",
                  message: (savings, remaining) =>
                    "You can probably pull it off technically, however, proceed with caution. You only have " +
                    remaining +
                    " to spare, after expenses. And if you've left anything off your budget—like savings goals, or debt pay down—you're house poor.",
                  value: 55
                },
                {
                  answer: "Mmm, you can barely afford this mortgage.",
                  message: () =>
                    "Well... you seem to have spare cash, but you're violating a common house-buying rule of thumb: keep your mortgage below 25% of your monthly income. This is important because you need to be able to weather financial storms, like unexpected expenses or a sudden shock to your income. Consider waiting, or find a cheaper home.",
                  value: 55
                },
                {
                  answer: "Can you afford this mortgage? Probably not, no.",
                  message: (savings) =>
                    "You should either wait to buy, or find a cheaper home: you're too close to the edge. You're saving " +
                    savings +
                    " of your monthly income, which is not enough slack to weather common financial storms like unexpected expenses or even mild changes in income.",
                  value: 25
                },
                {
                  answer: "Can you afford this mortgage? Probably not, no.",
                  message: () =>
                    "Technically you have enough loose cash, but your mortgage represents way too much of your income. Try to keep your mortgage payment to less than 25% of your monthly pay.",
                  value: 25
                },
                {
                  answer: "Can you afford this mortgage? Definitely not.",
                  message: () =>
                    "Your net income is negative. That means you will spend more than you earn for this mortgage. In no circumstances should you commit to a house you can't actually make payments on. Even if a bank offers you a loan, if you can't clear your monthly expenses (with room to spare), breathe, take a step back, and think of some different options.",
                  value: 10
                }
              ]
            }
          }
        ]
      },
      props
    )}
  />
)
